(function () {
  'use strict';

  angular.module('app').component('receivedPaymentList', receivedPaymentList());

  function receivedPaymentList() {
    return {
      bindings: {
        items: '=',
        meta: '<',
        totalItems: '=',
        paymentMethods: '<',
        onShowItem: '&',
      },
      controller: ReceivedPaymentListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/received-payments/received-payment-list/received-payment-list.component.html',
    };
  }

  ReceivedPaymentListComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'AbilityService',
    'SessionService',
    'moment',
    'ReceivedPaymentService',
    'currencyService',
  ];

  function ReceivedPaymentListComponent(
    config,
    UtilService,
    AbilityService,
    SessionService,
    moment,
    ReceivedPaymentService,
    currencyService
  ) {
    const vm = this;

    // public properties
    // -----------------------
    vm.UtilService = new UtilService(vm);

    vm.permissions = {
      canShow: AbilityService.can('show_receivedpayment_accountadmin'),
      canUpdate: AbilityService.can('update_receivedpayment_accountadmin'),
      canDestroy: AbilityService.can('destroy_receivedpayment_accountadmin'),
    };

    const apiUrl = 'received_payment_reports';
    vm.urlXls = apiUrl + '/export_payments_xls.xlsx';
    vm.urlPdf = apiUrl + '/export_payments_pdf.pdf';
    vm.reportName = 'received_payments_report';

    // private properties
    // -----------------------
    let userLanguageCode = SessionService.getUserLanguage().code;
    const company = SessionService.getSelectedAccountCompany();
    const dateDisplay = userLanguageCode !== 'es' ? 'MM/DD/YYYY' : 'DD/MM/YYYY';
    // const dateDisplay = config.DATE_DISPLAY_SHORT;

    vm.$onInit = function () {
      setReceivedPayments(vm.items);

      setDefaultFilters();

      setDocumentDatePicker();
      getCurrencies();
    };

    // public methods
    // -----------------------
    vm.fetchResult = function () {
      vm.loadingItems = true;
      ReceivedPaymentService.getReceivedPayments(vm.filterCriteria).then(function (data) {
        vm.items = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        setReceivedPayments(vm.items);

        vm.loadingItems = false;
      });
    };

    vm.refresh = function () {
      vm.fetchResult();
    };

    vm.selectPage = function (pge) {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      vm.fetchResult();
    };

    vm.onSort = function (sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      vm.fetchResult();
    };

    vm.showItem = function (item, mode) {
      if (!vm.permissions.canShow) return;

      vm.onShowItem({ item: item, mode: mode });
    };

    vm.deleteItem = function (item) {
      if (!vm.permissions.canDestroy) return;

      ReceivedPaymentService.deleteReceivedPayment(item, vm.fetchResult);
    };

    vm.clearDocumentDate = function () {
      vm.documentDatePicker = {
        startDate: '',
        endDate: '',
      };

      delete vm.filterCriteria.by_date_from;
      delete vm.filterCriteria.by_date_to;

      vm.UtilService.filterResult();
    };

    vm.clearSearch = function () {
      setDefaultFilters();

      vm.fetchResult();
    };

    // private methods
    // -----------------------
    function setReceivedPayments(items) {
      vm.sum_accounting_amount = 0;
      // items.map((item) => {
      items.forEach((item) => {
        vm.sum_accounting_amount += item.accounting_amount;
        item.date = moment(item.date).format(dateDisplay);

        item.client_name = item.client ? item.client.name + ' ' + item.client.last_name : '-';

        item.payment_method = vm.paymentMethods.find(
          (paymentMethod) => paymentMethod.code === item.payment_method_code
        );
      });
    }

    function setDefaultFilters() {
      vm.documentDatePicker = {
        startDate: vm.UtilService.startOfMonth(),
        endDate: vm.UtilService.today(),
        // startDate: '',
        // endDate: '',
      };

      vm.filterCriteria = ReceivedPaymentService.getFilterCriteria();

      vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
        vm.UtilService.startOfMonth()
      );

      vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.UtilService.today());
    }

    function setDocumentDatePicker() {
      let filterByDocumentDate = () => {
        vm.filterCriteria.by_date_from = vm.UtilService.startOfDayFormat(
          vm.documentDatePicker.startDate
        );

        vm.filterCriteria.by_date_to = vm.UtilService.endOfDayFormat(vm.documentDatePicker.endDate);

        vm.UtilService.filterResult();
      };

      vm.documentDateOptions = vm.UtilService.datePickerOptions({
        filterBy: filterByDocumentDate,
        rangeOptions: config.DOCUMENT_DATE_OPTIONS,
        dateDisplay: dateDisplay,
        maxDate: moment(),
      });
    }

    function getCurrencies() {
      currencyService.getCurrency(company.currency_id).subscribe((response) => {
        vm.base_currency = response;
      });
    }
  }
})();
